import { DataTable } from '../../../ui/data.table/data-table';
import HeadingWrapper from '../../../ui/heading/heading-wrapper';
import PageHeading from '../../../ui/heading/page-headeing';
import CreateRolePermission from '../create.role.permission/create-role-permission';
import RoleListHeadingActions from './role-list-heading-actions';
import { columns } from './role-permission.column';
import { useRolePermission } from './role-permission.hook';

export const RolePermissionList = () => {
    const { rolesPermissionsData, isLoading } = useRolePermission();

    return (
        <>
            <HeadingWrapper>
                <div className="flex items-center justify-between">
                    <PageHeading
                        title="Roles & Permissions"
                        subTitle="Manage Your Role with Permissions"
                    />
                    <RoleListHeadingActions />
                </div>
            </HeadingWrapper>
            <div className="mt-5 bg-white p-4 shadow-sm">
                {isLoading ? (
                    'Loading'
                ) : (
                    <DataTable
                        columns={columns}
                        data={rolesPermissionsData?.data}
                    />
                )}

                <CreateRolePermission />
            </div>
        </>
    );
};
